import { FunctionComponent, useEffect, useRef } from 'react';

import { SCRIPT_BUNDLE } from './constants';
import { RECAPTCHA_SITE_KEY } from '~/config';

const Recaptcha: FunctionComponent = function () {
  const recaptchaRef = useRef<boolean>(false);
  useEffect(() => {
    if (recaptchaRef.current) return;
    const s1 = document.createElement('script');
    s1.type = 'text/javascript';
    s1.src = SCRIPT_BUNDLE.replace('$RECAPTCHA_SITE_KEY', RECAPTCHA_SITE_KEY);
    document.head.appendChild(s1);
  }, []);

  return null;
};

export default Recaptcha;
